import { HttpErrorResponse } from '@angular/common/http';
import { FieldError } from '../model/api';

/**
 * This file contains all the base error classes.
 */
export type FieldErrorTree =
    | FieldError
    | { [field: string]: FieldError | FieldErrorTree };

export function isFieldError(obj: any): obj is FieldError {
    return obj?.code != null;
}

/**
 * This is the base interface that errors returned by FlyFreely services will implement
 */
export class FlyFreelyError extends Error {}

export class ValidationError extends FlyFreelyError {
    constructor(public fields: { [field: string]: FieldErrorTree }) {
        super('Request validation failed');
    }
}

export class InvalidOperation extends FlyFreelyError {
    constructor(
        public reason: string,
        message: string,
        public code: string,
        public fields: { [field: string]: FieldErrorTree },
        public fieldErrors: { [field: string]: FieldErrorTree },
        public stateErrors: { [field: string]: FieldErrorTree }
    ) {
        super(message);
    }
}

export class OperationFailed extends FlyFreelyError {
    constructor(
        public reason: string,
        message: string,
        public code: string,
        public fields: { [field: string]: FieldErrorTree }
    ) {
        super(message);
    }
}

export class CardDeclinedException extends FlyFreelyError {
    constructor(
        public declineCode: string,
        message: string,
        public code: string,
        public fields: { [field: string]: FieldErrorTree }
    ) {
        super(message);
    }
}

export class NoAccess extends FlyFreelyError {
    constructor(
        public declineCode: string,
        message: string,
        public code: string,
        public fields: { [field: string]: FieldErrorTree }
    ) {
        super(message);
    }
}

export class SessionExpired extends FlyFreelyError {
    constructor() {
        super('Session expired');
    }
}

export class Unauthorised extends FlyFreelyError {
    constructor() {
        super('Invalid username or password');
    }
}

export class OperationForbidden extends FlyFreelyError {
    constructor() {
        super('Operation forbidden');
    }
}

export class NotFound extends FlyFreelyError {
    constructor() {
        super('Not found');
    }
}

export class TemplateError extends FlyFreelyError {
    constructor(message: string, public line: number) {
        super(message);
    }
}

export class UnknownError extends FlyFreelyError {
    constructor(public response: HttpErrorResponse) {
        super(response.message);
    }
}
